var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bank") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Badge/Icon-7",
    transform: "translate(-9.000000, -9.000000)",
    stroke: "#989FB2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "16 4.17391304 0 4.17391304 0 2.7826087 8 0 16 2.7826087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.39130435,13.2173913 L14.6086957,13.2173913 C15.373913,13.2173913 16,13.8434783 16,14.6086957 L16,16 L0,16 L0,14.6086957 C0,13.8434783 0.626086957,13.2173913 1.39130435,13.2173913 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 2.08695652,
    y: 4.17391304,
    width: 2.08695652,
    height: 9.04347826
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 6.95652174,
    y: 4.17391304,
    width: 2.08695652,
    height: 9.04347826
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    x: 11.826087,
    y: 4.17391304,
    width: 2.08695652,
    height: 9.04347826
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.299515c5.svg";
export { ForwardRef as ReactComponent };